/**
 * @generated SignedSource<<9365636eb4faad2a9667cd4be8be4022>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type goalTitleMetadata_AtlassianSearchPage$data = {
  readonly goal: {
    readonly status: {
      readonly localizedLabel: {
        readonly messageId: string | null;
      } | null;
      readonly score: number | null;
      readonly value: string | null;
    } | null;
    readonly targetDate: {
      readonly label: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "goalTitleMetadata_AtlassianSearchPage";
};
export type goalTitleMetadata_AtlassianSearchPage$key = {
  readonly " $data"?: goalTitleMetadata_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"goalTitleMetadata_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goalTitleMetadata_AtlassianSearchPage",
  "selections": [
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareLocalizationField",
              "kind": "LinkedField",
              "name": "localizedLabel",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "messageId"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "score"
            }
          ]
        },
        {
          "concreteType": "TownsquareTargetDate",
          "kind": "LinkedField",
          "name": "targetDate",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "label"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultAtlasGoal"
};

(node as any).hash = "c30318c731fc2ff06bbb542cb5aa234a";

export default node;
